import angular from 'angular';

angular.module('myConsultApp').directive('numericPagination', () => {
  return {
    templateUrl: 'templates/numericPagination.html',
    restrict: 'E',
    scope: {
      gotoPageFn: '&',
      pageSize: '=',
      currentPage: '=',
      totalCount: '=',
    },
    link: ($scope) => {
      $scope.pageSize = $scope.pageSize || 10;
      $scope.totalCount = $scope.totalCount || 1;
      $scope.currentPage = $scope.currentPage || 1;

      $scope.totalPages = Math.ceil($scope.totalCount / $scope.pageSize);
      $scope.displayedPages = [];

      $scope.generateDisplayedPages = () => {
        const pages = [];
        if ($scope.totalPages <= 7) {
          for (let i = 1; i <= $scope.totalPages; i += 1) {
            pages.push(i);
          }
        } else if ($scope.currentPage >= 1 && $scope.currentPage <= 3) {
          for (let i = 1; i <= 4; i += 1) {
            pages.push(i);
          }
          pages.push('...');
          pages.push($scope.totalPages);
        } else if ($scope.currentPage >= $scope.count - 3) {
          pages.push(1);
          pages.push('...');
          for (let i = $scope.totalPages - 3; i <= $scope.totalPages; i += 1) {
            pages.push(i);
          }
        } else {
          pages.push(1);
          pages.push('...');
          pages.push($scope.currentPage - 1);
          pages.push($scope.currentPage);
          pages.push($scope.currentPage + 1);
          pages.push('...');
          pages.push($scope.count);
        }
        $scope.displayedPages = [...pages];
      };

      $scope.goToPage = (page) => {
        if (page !== '...' && $scope.currentPage !== page) {
          $scope.gotoPageFn({ page });
        }
      };

      $scope.goToPrev = () => {
        if ($scope.currentPage > 1) {
          $scope.gotoPageFn({ page: $scope.currentPage - 1 });
        }
      };

      $scope.goToNext = () => {
        if ($scope.currentPage < $scope.totalPages) {
          $scope.gotoPageFn({ page: $scope.currentPage + 1 });
        }
      };

      $scope.$watch('totalCount', () => {
        $scope.generateDisplayedPages();
      });

      $scope.$watch('pageSize', () => {
        $scope.generateDisplayedPages();
      });
    },
  };
});
